<template>
  <urun-areas-layout>
    <div>
      <div class="mb-3">
        <div>
          <panel-title
            icon="mdi-label"
            :title="$t('URUNLER.PRODUCT_PREFERENCES.PREFERENCES_AREA.TITLE')"
            :desc="$t('URUNLER.PRODUCT_PREFERENCES.PREFERENCES_AREA.SUB_TITLE')"
          >
            <template v-slot:append-inner>
              <v-btn color="success" class="text-capitalize" small dark @click="secenekleriGuncelle">
                <v-icon size="16" class="mr-1">mdi-autorenew</v-icon>
                {{ $t("URUNLER.PRODUCT_PREFERENCES.PREFERENCES_AREA.UPDATE_PREFERENCES_BTN") }}
              </v-btn>
            </template>
          </panel-title>
        </div>
      </div>
      <div>
        <v-card class="px-4 py-4">
          <list-inputs :solo="true" :inputs="inputList" @input="inputData" />
        </v-card>
      </div>
    </div>
  </urun-areas-layout>
</template>

<script>
import PanelTitle from "../../../../components/PanelTitle.vue";
import UrunAreasLayout from "./UrunAreasLayout.vue";
import { mapState } from "vuex";
import ListInputs from "../../../../components/Settings/SystemSettings/ListInputs.vue";

export default {
  components: { UrunAreasLayout, PanelTitle, ListInputs },
  name: "UrunSecenekleri",
  computed: {
    ...mapState({
      inputList: state => state.Option.ModuleOptions.inputList,
      apiLanguage: state => state.Language.apiLanguage
    }),
    getType() {
      const optionType = "Modules",
        optionName = "Urunler";
      return { optionType, optionName };
    },
    sysName() {
      return { optionSysName: "urunSecenekleri" };
    }
  },
  methods: {
    /**
     *  Ayar listesini güncelle
     */
    secenekleriGuncelle() {
      const inputList = this.inputList;
      this.$store
        .dispatch("Option/ModuleOptions/updateInputList", {
          inputList,
          ...this.sysName,
          ...this.getType
        })
        .then(res => {
          if (res.status === 200) {
            this.$snotify.success(this.$t("PANEL.NOTIFY.PREFERENCES_UPDATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else {
            this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
          }
        });
    },
    inputData() {}
  },
  created() {
    this.$store.commit("Option/ModuleOptions/setLang", this.apiLanguage);

    this.$store.dispatch("Option/ModuleOptions/getInputList", {
      ...this.sysName,
      ...this.getType,
      lang: this.apiLanguage
    });
  }
};
</script>

<style></style>
